import React, { useEffect, useState } from 'react';
import { Client } from '@ujet/websdk-headless';
import { Fab } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import { ChatbotWidgetContext } from './utils/ChatbotWidgetContext';
import { View } from './constants/view';
import { WidgetPopover } from './components/WidgetPopover';
import styles from './ChatbotWidget.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const CN = 'chatbot-widget';
const fabClassName = `${CN}__fab`;

export interface ChatbotWidgetOptions {
  host: string;
  companyId: string;
  menuId: number;
  apiUrl: string;
  logoUrl: string;
  supportPhoneNumber?: string;
  user: {
    name: string;
    email: string;
  }
}

export const ChatbotWidget = (options: ChatbotWidgetOptions): React.ReactElement => {
  const [ anchorEl, setAnchorEl ] = useState<null | HTMLElement>(null);

  const [ view, setView ] = useState(View.SELECT_CONTACT_OPTION);
  const [ client, setClient ] = useState<Client | null>(null);
  const [ name, setName ] = useState('');
  const [ email, setEmail ] = useState('');
  const [ phone, setPhone ] = useState('');

  useEffect((): void => {
    setName(options.user.name);
    setEmail(options.user.email);
  }, [ options.user.name, options.user.email ]);

  return (
    <ChatbotWidgetContext.Provider
      value={ {
        view,
        setView,
        client,
        setClient,
        options,
        user: {
          name,
          setName,
          email,
          setEmail,
          phone,
          setPhone
        }
      } }
    >
      <div className={ cx(CN) }>
        <Fab
          color='primary'
          onClick={ (e): void => setAnchorEl(e.currentTarget) }
          className={ cx(fabClassName) }
        >
          <ChatIcon />
        </Fab>
        <WidgetPopover
          anchorEl={ anchorEl }
          close={ (): void => setAnchorEl(null) }
        />
      </div>
    </ChatbotWidgetContext.Provider>
  );
};
